// redux/reducers/authUserReducer.js
const initialState = {
  user: null,
  isAuthenticated: false,
  userLoading: false,
  role: null,
  error: null,
  redirect: null,
  token: null,
};

const authUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        user: action.payload.user,
        isAuthenticated: true,
        role: action.payload.user.profile,
        error: null,
        token: action.payload.jwt,
      };
    case "LOGIN_FAILURE":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        role: null,
        error: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        role: null,
        error: null,
      };
    case "USERDATA_SUCCESS":
      return {
        ...state,
        user: action.payload,
        role: action.payload.profile,
        userLoading: false,
        isAuthenticated: true,
        error: null,
      };
    case "USERS_LOADING":
      return { ...state, userLoading: true, error: null };
    case "USER_ERROR":
      return { ...state, userLoading: false, error: action.payload };
    case "UNAUTHORIZED":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        role: null,
        userLoading: false,
        error: "Unauthorized",
        redirect: "/login",
      };
    default:
      return state;
  }
};

export default authUserReducer;
